import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {ShardDto} from "../../models/admin_owner/shard/shard-dto";
import {ServerEndpoints} from "../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class ShardHttpService {

  constructor(private httpClient: HttpClient,
              @Inject('BASE_URL') private baseUrl: string,
              @Inject('BASE_HEADERS') private baseHeaders: HttpHeaders) {
  }

  list(company: string): Observable<ShardDto[]> {
    return this.httpClient.get<ShardDto[]>(this.baseUrl + ServerEndpoints.Management_Shard_List + "?company=" + company, {headers: this.baseHeaders});
  }

  delete(id: string) {
    return this.httpClient.delete(this.baseUrl + ServerEndpoints.Management_Shard_Delete + "?id=" + id, {headers: this.baseHeaders});
  }

  get(id: string): Observable<ShardDto> {
    return this.httpClient.get<ShardDto>(this.baseUrl + ServerEndpoints.Management_Shard_Get + "?id=" + id, {headers: this.baseHeaders});
  }

  setProperty(id: string, variable: string, value: string): Observable<ShardDto> {
    return this.httpClient.post<ShardDto>(`${this.baseUrl}${ServerEndpoints.Management_Shard_SetMetadata_$id$.dictReplace({id: id})}`, {
      name: variable,
      value: value
    })
  }
}
